// Textes de la page de compte
export const ACCOUNT_TEXTS = {
  title: 'Compte',
  profile: 'Informations de profil',
  profileMenuItem: 'Profil',
  email: 'Email',
  name: 'Nom',
  organization: 'Organisation',
  role: 'Rôle',
  changePassword: 'Changer le mot de passe',
  currentPassword: 'Mot de passe actuel',
  newPassword: 'Nouveau mot de passe',
  confirmPassword: 'Confirmer le nouveau mot de passe',
  passwordChanged: 'Mot de passe modifié avec succès',
  passwordError: 'Échec de la modification du mot de passe',
  loading: 'Modification du mot de passe...',
  errors: {
    PASSWORD_EMPTY: 'Le mot de passe ne peut pas être vide',
    PASSWORD_CONFIRMATION_EMPTY: 'Veuillez confirmer votre mot de passe',
    PASSWORD_TOO_SHORT: 'Le mot de passe doit contenir au moins 6 caractères',
    PASSWORDS_DO_NOT_MATCH: 'Les mots de passe ne correspondent pas',
    CHANGE_PASSWORD_FAILED: 'Échec de la modification du mot de passe'
  }
} as const;